// extracted by mini-css-extract-plugin
export var cardHeader = "_gc-0";
export var reorderHandle = "_gc-3";
export var titleArea = "_gc-1";
export var titleAreaWithHandle = "_gc-2";